





























import { Component, Vue } from 'vue-property-decorator'
import { Getter, State } from 'vuex-class'
import { PronosticoHidricoEstacionState } from '@/store/modules/pronostico-hidrico-estacion/types'
import LogoAlertaHidrica from '@/components/LogoAlertaHidrica.vue'
import MapCustomControl from '@/components/MapCustomControl.vue'
import { GoogleMapPosition, GoogleMapMarker, GoogleMapOverlay } from '@/store/modules/google-maps/types'
import InfoView from '../components/InfoView.vue'
import DesktopCustomControl from '@/components/DesktopCustomControl.vue'
import { ResizeObserver } from 'resize-observer'
import { ResizeObserverEntry } from 'resize-observer/src/ResizeObserverEntry'
import TheMap from '@/components/TheMap.vue'
const GOOGLE_MAPS_MODULE = 'googleMaps'

const MODULE_ESTACION = 'pronosticoHidricoEstacion'

@Component({
  components: {
    LogoAlertaHidrica,
    MapCustomControl,
    DesktopCustomControl,
    TheMap
  }
})
export default class MapLayout extends Vue {
  @State(MODULE_ESTACION)
  public pronosticoEstacion!: PronosticoHidricoEstacionState
  @Getter('groundOverlays', { namespace: GOOGLE_MAPS_MODULE }) groundOverlays!: GoogleMapOverlay[]
  @Getter('overlayViews', { namespace: GOOGLE_MAPS_MODULE }) overlays!: GoogleMapOverlay[]
  @Getter('position', { namespace: GOOGLE_MAPS_MODULE }) position!: GoogleMapPosition
  @Getter('zoom', { namespace: GOOGLE_MAPS_MODULE }) zoom!: number
  @Getter('markers', { namespace: GOOGLE_MAPS_MODULE }) markers!: GoogleMapMarker[]
  @Getter('infoView', { namespace: GOOGLE_MAPS_MODULE }) infoView!: InfoView
  @Getter('autocomplete', { namespace: GOOGLE_MAPS_MODULE }) autocomplete!: { shown: boolean }
  @Getter('openDefaultMarkerOption', { namespace: GOOGLE_MAPS_MODULE }) openDefaultMarkerOption!: boolean
  @Getter('defaultMarker', { namespace: GOOGLE_MAPS_MODULE }) defaultMarker!: boolean

  private isMobile: boolean = true

  center: any = {
    lat: -33.5844819,
    lng: -70.4667903
  }
  mapOptions: google.maps.MapOptions = {
    gestureHandling: 'greedy',
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    disableDefaultUI: false,
    zoomControlOptions: {
      position: 3 // ControlOptions.TOP_RIGHT
    }
  }

  created () {
    this.$root.$on('center-map', (
      { position, zoom }: {position: GoogleMapPosition, zoom?: number}
    ) => {
      this.center = position
      if (zoom) this.zoom = zoom
    })
  }
  mounted () {
    // This function observes if there are changes in the size of the view (eg: portrait to landscape)
    // and enables or disables certain features according to the size
    const myObserver = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      entries.forEach((element: ResizeObserverEntry) => {
        if (element.contentRect.width < 1280) {
          this.mapOptions.disableDefaultUI = true
          this.mapOptions.zoomControl = false
          this.isMobile = true
        }
        if (element.contentRect.width >= 1280) {
          this.mapOptions.disableDefaultUI = true
          this.mapOptions.zoomControlOptions = {
            position: 3 // ControlOptions.TOP_RIGHT
          }
          this.isMobile = false
        }
      })
    })
    const observableElement = document.querySelector('#app')
    if (observableElement) myObserver.observe(observableElement)
  }
  get computedIsMobile () {
    return this.isMobile
  }
}
